export const POSITION_MAIN = 'position/main';
export const POSITION_SUB = 'position/sub';
export const POSITION_SUB_TOP = 'position/sub_top';
export const LIKE_OPTION_DEL = 'DEL';
export const LIKE_OPTION_INSERT = 'INSERT';
export const REFRESH_SUB_COMMENTS_TYPE_INSERT = 'insert';
export const REFRESH_SUB_COMMENTS_TYPE_DEL = 'del';
